import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Statistic from './index';

/**
 * userRank가 1보다 크면 통계분석 페이지 접근 불가 → /home으로 리다이렉트
 */
function StatisticGuard() {
    const userRank = useSelector((state) => state.session?.userRank ?? 99);
    if (userRank > 1) {
        return <Navigate to="/home" replace />;
    }
    return <Statistic />;
}

export default StatisticGuard;
